import * as React from 'react';

import styles from './styles/EnterDongTooltip.module.css';

export const EnterDongTooltip: React.FC = () => {
  return (
    <div className={`${styles.tooltipContainer} ${styles.animated}`} onClick={(e) => {
      e.stopPropagation();
    }}>
      <div className={styles.tooltipContent}>
        <div className={styles.tooltipText}>
          클릭해서 세대에 <br/>진입해 보세요
        </div>
      </div>
      <div className={styles.tooltipArrowTop}></div>
      <div className={styles.tooltipArrowBottom}></div>
    </div>
  );
}; 
